import { ItemsResponse } from '@/features/items/types/item'
import { apiClient } from '@/lib/api/api-client'
import { Department, DepartmentDetail, DepartmentOption } from '../types/department'

const DEPARTMENT_ENDPOINT = '/departments'

export const departmentApi = {
  getDepartments: (params?: { buildingId?: string; floorId?: string }) => {
    return apiClient.get<Department[]>(DEPARTMENT_ENDPOINT, { params })
  },

  getDepartmentOptions: (params?: {
    buildingId?: string
    floorId?: string
    excludeDepartmentId?: string
    excludeWarehouse?: boolean
  }) => {
    return apiClient.get<DepartmentOption[]>(`${DEPARTMENT_ENDPOINT}/options`, { params })
  },

  getDepartment: (id: string) => {
    return apiClient.get<DepartmentDetail>(`${DEPARTMENT_ENDPOINT}/${id}`)
  },

  createDepartment: (payload: any) => {
    return apiClient.post<Department>(DEPARTMENT_ENDPOINT, payload)
  },

  updateDepartment: (id: string, payload: any) => {
    return apiClient.put<Department>(`${DEPARTMENT_ENDPOINT}/${id}`, payload)
  },

  deleteDepartment: (id: string) => {
    return apiClient.delete<void>(`${DEPARTMENT_ENDPOINT}/${id}`)
  },

  getDepartmentItems: (id: string, params?: { status?: string; excludeOwnedProductItems?: boolean }) => {
    return apiClient.get<ItemsResponse>(`${DEPARTMENT_ENDPOINT}/${id}/items`, { params })
  },
}
